import { CookiePreferences, CookieCategory } from '../types';

const COOKIE_CONSENT_KEY = 'zwheel_cookie_consent';
const COOKIE_PREFERENCES_KEY = 'zwheel_cookie_preferences';

// 默认cookie偏好设置（必要cookie始终启用）
const defaultPreferences: CookiePreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
  consentGiven: false,
};

/**
 * 从localStorage读取cookie偏好设置
 */
export function getCookiePreferences(): CookiePreferences {
  if (typeof window === 'undefined') {
    return defaultPreferences;
  }

  try {
    const stored = localStorage.getItem(COOKIE_PREFERENCES_KEY);
    if (stored) {
      const preferences = JSON.parse(stored) as CookiePreferences;
      // 确保必要cookie始终为true
      preferences.necessary = true;
      return preferences;
    }
  } catch (error) {
    console.error('读取cookie偏好设置失败:', error);
  }

  return defaultPreferences;
}

/**
 * 保存cookie偏好设置到localStorage
 */
export function saveCookiePreferences(preferences: CookiePreferences): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    // 确保必要cookie始终为true
    const preferencesToSave: CookiePreferences = {
      ...preferences,
      necessary: true,
      consentGiven: true,
      consentDate: new Date().toISOString(),
    };
    localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(preferencesToSave));
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
  } catch (error) {
    console.error('保存cookie偏好设置失败:', error);
  }
}

/**
 * 检查用户是否已给出cookie同意
 */
export function hasCookieConsent(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    return consent === 'true';
  } catch (error) {
    console.error('检查cookie同意状态失败:', error);
    return false;
  }
}

/**
 * 检查特定类别的cookie是否被允许
 */
export function isCookieCategoryAllowed(category: CookieCategory): boolean {
  const preferences = getCookiePreferences();
  
  // 必要cookie始终允许
  if (category === 'necessary') {
    return true;
  }

  return preferences[category] === true;
}

/**
 * 清除所有cookie偏好设置（用于测试或重置）
 */
export function clearCookiePreferences(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(COOKIE_PREFERENCES_KEY);
    localStorage.removeItem(COOKIE_CONSENT_KEY);
  } catch (error) {
    console.error('清除cookie偏好设置失败:', error);
  }
}

